import { ProfileCardProps } from '..'
import { useCashAppConsumerName, useConsumerName, useConsumerSelector, useCountry } from '../../state'
import { DesignLanguage, useIsDesignLanguage, usePhoneNumber } from '@afterpaytouch/core'

export const useProfileCardProps = (): ProfileCardProps => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const countryCode = useCountry()
  const profileConsumerName = useConsumerName()
  const cashAppConsumerName = useCashAppConsumerName()
  const { email } = useConsumerSelector()
  const { mobile: rawMobile } = useConsumerSelector()

  const consumerName = profileConsumerName.length > 0 ? profileConsumerName : cashAppConsumerName
  const mobile = usePhoneNumber({ country: countryCode }).formatIntMaskedNumber(rawMobile)

  if (isArcadeDesignLanguage) {
    return {
      header: consumerName,
      customSubheader: email,
      hideSubheader: false,
    }
  }

  return { header: mobile }
}
